export const GET_SERVICE_PROVIDER_DASHBOARD_INDEX_LIST = null;
export const GET_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_LIST = null;
export const GET_SERVICE_PROVIDER_DASHBOARD_SALES_METRICS_LIST = null;
